import AuctionContract from './Auction.json';
import BulletCollectorTokenKeeperContract from './BulletCollectorTokenKeeper.json';
import ContractGeneratorContract from './ContractGenerator.json';
import eDOBContract from './eDOB.json';
import DOBStakingPoolContract from './DOBStakingPool.json';
import DistributionsContract from './Distributions.json';
import GoldGeregeContract from './GoldGerege.json';
import HODLStakingPoolRewarderContract from './HODLStakingPoolRewarder.json';
import HODLStakingPoolsContract from './HODLStakingPools.json';
import MatchingMarketContract from './MatchingMarket.json';
// import NFTContract from './NFT.json';
import OptionFactoryContract from './OptionFactory.json';
import RewardDispatcherTokenKeeperContract from './rewardDispatcherTokenKeeper.json';
import SilverGeregeContract from './SilverGerege.json';
import StakingPoolRewarderContract from './StakingPoolRewarder.json';
import StakingPoolsContract from './StakingPools.json';
// import TokenFactoryContract from './TokenFactory.json';
import TestTokenPool from './TestTokenPool.json';
import TokenKeeperContract from './TokenKeeper.json';
import USDCContract from './USDC.json';
import WETHContract from './WETH.json';
import eHODLContract from './eHODL.json';
import eHODLRewarderContract from './eHODLRewarder.json';
import feeCollectorTokenKeeperContract from './feeCollectorTokenKeeper.json';
import uHODLContract from './uHODL.json';
import uHODLRewarderContract from './uHODLRewarder.json';
export const AuctionAddressScrollSepolia = AuctionContract.address;
export const BulletCollectorTokenKeeperAddressScrollSepolia = BulletCollectorTokenKeeperContract.address;
export const ContractGeneratorAddressScrollSepolia = ContractGeneratorContract.address;
export const eDOBAddressScrollSepolia = eDOBContract.address;
export const DOBStakingPoolAddressScrollSepolia = DOBStakingPoolContract.address;
export const DistributionsAddressScrollSepolia = DistributionsContract.address;
export const GoldGeregeAddressScrollSepolia = GoldGeregeContract.address;
export const HODLStakingPoolRewarderAddressScrollSepolia = HODLStakingPoolRewarderContract.address;
export const HODLStakingPoolsAddressScrollSepolia = HODLStakingPoolsContract.address;
export const MatchingMarketAddressScrollSepolia = MatchingMarketContract.address;
// export const NFTAddressScrollSepolia = NFTContract.address;
export const OptionFactoryAddressScrollSepolia = OptionFactoryContract.address;
export const RewardDispatcherTokenKeeperAddressScrollSepolia = RewardDispatcherTokenKeeperContract.address;
export const SilverGeregeAddressScrollSepolia = SilverGeregeContract.address;
export const StakingPoolRewarderAddressScrollSepolia = StakingPoolRewarderContract.address;
export const StakingPoolsAddressScrollSepolia = StakingPoolsContract.address;
// export const TokenFactoryAddressScrollSepolia = TokenFactoryContract.address;
export const TestTokenPoolAddressScrollSepolia = TestTokenPool.address;
export const TokenKeeperAddressScrollSepolia = TokenKeeperContract.address;
export const USDCAddressScrollSepolia = USDCContract.address;
export const WETHAddressScrollSepolia = WETHContract.address;
export const eHODLAddressScrollSepolia = eHODLContract.address;
export const eHODLRewarderAddressScrollSepolia = eHODLRewarderContract.address;
export const feeCollectorTokenKeeperAddressScrollSepolia = feeCollectorTokenKeeperContract.address;
export const uHODLAddressScrollSepolia = uHODLContract.address;
export const uHODLRewarderAddressScrollSepolia = uHODLRewarderContract.address;
//# sourceMappingURL=index.js.map